import Type from "@/model/types/Type";

const type = {

    START: 1,
    FINISH: 2,
    RETURN: 3,
    STOP: 4,
    CANCEL_STOP: 5,
    SET_RESPONSIBLE: 6,
    START_EXECUTION: 7,
    FINISH_EXECUTION: 8,
    SET_GROUP_USER: 9,
    SET_OPERATION_STATUS: 10,
    FINISH_WITH_SUCCESS: 20,
    FINISH_WITH_ERROR: 90,
}

const list = [
    {
        value: type.START,
        text: "Iniciar",
        returnMessage: 'iniciada'
    },
    {
        value: type.FINISH,
        text: "Finalizar",
        returnMessage: 'finalizada'
    },
    {
        value: type.RETURN,
        text: "Retornar",
        returnMessage: 'retornada'
    },
    {
        value: type.STOP,
        text: "Parar",
        returnMessage: 'paralizada'
    },
    {
        value: type.CANCEL_STOP,
        text: "Cancelar a paralização",
        returnMessage: 'cancelada paralização'
    },
    {
        value: type.SET_RESPONSIBLE,
        text: "Responsabilizar",
        returnMessage: 'responsabilizada'
    },
    {
        value: type.SET_GROUP_USER,
        text: "Responsabilizar",
        returnMessage: 'responsabilizada'
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional",
        returnMessage: 'status operacional alterado'
    },
    {
        value: type.START_EXECUTION,
        text: "Iniciar Execução", /*??? acredito que neste contexto não seja utilizado*/
        returnMessage: 'iniciada Execução'
    },
    {
        value: type.FINISH_EXECUTION,
        text: "Finalizar Execução", /*??? acredito que neste contexto não seja utilizado*/
        returnMessage: 'finalizada Execução'
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar com erro",
        returnMessage: 'finalizada definitivamente'
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar com sucesso",
        returnMessage: 'finalizada definitivamente'
    },
]

const contains = function (type) {
    return Type.contains(list, type)
}

const getText = function (type) {
    return Type.getText(list, type)
}

const getReturnMessage = function(type){

    const message = list.find(a => a.value === type).returnMessage

    if(message !== undefined){
        return message
    }else{
        return null
    }

}

export default {
    type,
    list,
    contains,
    getText,
    getReturnMessage,
}


